import { inject, Injectable } from '@angular/core';
import { MyArvatoEnvironment } from '@myarvato/shared/models';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserLayoutDto } from '../models/user-layout-dto';

@Injectable({
  providedIn: 'root',
})
export class CustomizationLayoutsService<T> {
  // Injections
  private readonly environment = inject(MyArvatoEnvironment);
  private readonly httpClient = inject(HttpClient);

  // Fields
  private readonly baseUrl = `${this.environment.url.api}Customization/UserLayouts/Layout`;

  public getLayouts(context: string): Observable<UserLayoutDto<T>[]> {
    return this.httpClient.get<UserLayoutDto<T>[]>(this.baseUrl, {
      ...this.getRequestOptions(),
      params: { context },
    });
  }

  private getRequestOptions() {
    const headers = new HttpHeaders({
      'x-skip-all-interceptor-handling': 'true',
      'x-skip-loading-interceptor-handling': 'true',
      'x-error-message-target-key': 'none',
    });

    return { headers: headers };
  }
}
